// SPDX-License-Identifier: BUSL-1.1

/**
 * Resource pill — small colored pill for inline resource references
 * in natural-language activity feeds.
 *
 */

import type * as React from 'react';

interface ResourcePillProps {
  variant: 'blue' | 'green' | 'amber' | 'red' | 'purple';
  children: React.ReactNode;
}

const VARIANTS: Record<ResourcePillProps['variant'], string> = {
  blue: 'bg-blue-950/40 text-blue-400',
  green: 'bg-green-950/40 text-green-400',
  amber: 'bg-amber-950/40 text-amber-400',
  red: 'bg-red-950/40 text-red-400',
  purple: 'bg-purple-950/40 text-purple-400',
};

export function ResourcePill({ variant, children }: ResourcePillProps): React.ReactElement {
  return (
    <span className={`inline-block rounded px-1.5 font-mono text-[11px] ${VARIANTS[variant]}`}>
      {children}
    </span>
  );
}
